import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'underscore';

import { Invoice } from 'services/action';
import { Page } from 'ui/components';
import {
  Action,
  DetailInvoice,
  DetailPayment,
  Orders,
  PaymentList,
  AdditionalList
} from './component/detail';

const initialState = {
  data: null,
  privilege: null,
};

const DetailScreen = ({ match }) => {
  const Dispatch = useDispatch();
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Invoice.Show']
  );
  const Session = useSelector((state) => state.Auth?.session);

  const [{ data, privilege }, setState] = React.useState(initialState);

  const $onLoad = async (e) => {
    const req = await Dispatch(Invoice.$show(e));

    if (req?.message === 'success') {
      setState((prevState) => ({ ...prevState, data: req?.data }));
    }
  };

  const $getPriviledge = async () => {
    const x = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.invoice',
    });
    setState((prevState) => ({ ...prevState, privilege: x }));
  };

  React.useEffect(() => {
    $getPriviledge();
  }, []);

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, []);

  return (
    <Page className="col-lg-11 col-md-11 bordered">
      <Page.Header
        pretitle="Invoice"
        title={data?.code}
        status={data?.document_status}
        backTo="/invoice"
      >
        <Action data={data} onSubmit={() => $onLoad(match?.params?.id)} />
      </Page.Header>

      <Page.Body className="bg-white border-top padding mt-3 mt-md-0">
        <div className="row">
          <div className="col-md-9">
            <div className="row">
              <div className="col-md-6">
                <DetailInvoice
                  data={data}
                  privilege={!Session?.privileges || privilege?.invoice}
                />
              </div>

              <div className="col-md-6">
                <DetailPayment
                  data={data}
                  privilege={!Session?.privileges || privilege?.invoice}
                />
              </div>
            </div>
            <Orders data={data} isLoading={StateLoading} />
          </div>
          <div className="border-start border-sm-none col-md-3 mt-3 mt-md-0">
            <PaymentList
              data={data}
              onSubmit={() => $onLoad(match?.params?.id)}
              privilege={
                !Session?.privileges ||
                privilege?.invoice?.action === 'manage'
              }
            />
            <AdditionalList
              data={data}
              onSubmit={() => $onLoad(match?.params?.id)}
              privilege={
                !Session?.privileges ||
                privilege?.invoice?.action === 'manage'
              }
            />
          </div>
        </div>
      </Page.Body>
    </Page>
  );
};

export default DetailScreen;
